import GameVersion from 'app/frontend/types/custom/GameVersion'

export const liveOnlyNotificationTemplateKeys = [
  'character-vault-options',
  'character-crests-not-capped',
  'wishlist-missing',
  'wishlist-missing-summary',
  'wishlist-update',
]

export const notificationTemplateVisibleForGameVersion = (
  key: string,
  gameVersion: GameVersion,
): boolean =>
  gameVersion === 'live' || !liveOnlyNotificationTemplateKeys.includes(key)
